<template>
  <div>
    <v-app>
      <v-container>
        <v-layout wrap>
          <v-flex sm12 md6 offset-md3>
            <v-card elevation="4" light tag="section">
              <v-card-title>
                <v-layout align-center justify-space-between>
                  <h3 class="headline">
                    Cargo
                  </h3>
                  <v-flex>
                    <!-- <v-img
                      class="ml-3"
                      contain
                      height="48px"
                      position="center right"
                      src="https://www.mobygames.com/images/i/12/25/1435075.png"
                    ></v-img> -->
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <!-- <p>Sign in with your username and password:</p> -->
                <v-form>
                  <v-combobox
                    label="Port Awal"
                    :items="items.portAwal"
                    :loading="loadingPortAwal"
                    :disabled="loadingPortAwal"
                    v-model="formData.port_awal"
                    dense
                    hide-details
                    ref="focusPortAwal"
                  >
                  </v-combobox>
                  <v-text-field
                    outline
                    label="Username"
                    type="text"
                    hide-details
                    v-model="formData.username"
                  ></v-text-field>
                  <v-text-field
                    outline
                    hide-details
                    label="Password"
                    type="password"
                    @keydown.enter="login"
                    v-model="formData.password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions :class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
                <v-spacer></v-spacer>
                <v-btn
                  color="info"
                  @click="login"
                  :disabled="loading"
                  :loading="loading"
                >
                  Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginView",
  data() {
    return {
      formData: {
        username: "",
        password: "",
        port_awal: ""
      },
      items: {
        portAwal: []
      },
      loadingPortAwal: false,
      loading: false
    };
  },
  methods: {
    async login() {
      this.loading = true;

      await axios
        .post(`auth/login`, this.formData)
        .then(res => {
          this.loading = false;

          localStorage.setItem("token", res.data.token);
          localStorage.setItem("user", JSON.stringify(res.data.user));
          localStorage.setItem(
            "port_awal",
            JSON.stringify(this.formData.port_awal)
          );

          this.$router.push("/");
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    async fetchPortAwal() {
      await axios
        .get(`port-awal`)
        .then(res => {
          this.items.portAwal = res.data.map(item => ({
            text: item.kota,
            value: item.id
          }));
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    }
  },
  created() {
    this.fetchPortAwal();
  }
};
</script>
